import { render, staticRenderFns } from "./CourseSeting.vue?vue&type=template&id=437ec5a0"
import script from "./CourseSeting.vue?vue&type=script&lang=js"
export * from "./CourseSeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports